import { object, string } from 'yup';
import { LocationFormValues } from './types';
import { pkValidation } from '../../../../utils/pkValidation';
import i18n from '../../../../i18n';
import { PK_FORMAT_REGEX } from '../../../../utils/transform';

export const createLocationSchema = (
  directionRequired: boolean,
  marginRequired = true,
) => object<LocationFormValues>({
  actionConcession: string().required(() => i18n.t('validation:required')),
  actionCity: string().required(() => i18n.t('validation:required')),
  actionPkInitRoad: string().required(() => i18n.t('validation:required')),
  actionPkEndRoad: string().required(() => i18n.t('validation:required')),
  actionRoad: string().required(() => i18n.t('validation:required')),
  actionPkInit: string()
    .matches(PK_FORMAT_REGEX, () => i18n.t('validation:pk.format'))
    .test('pk-validation', function (value) {
      if (PK_FORMAT_REGEX.test(value || '') && pkValidation(value || '', this.parent)) {
        return true;
      }
      return this.createError({ message: i18n.t('validation:pk.validation') });
    })
    .required(() => i18n.t('validation:required')),
  actionPkEnd: string()
    .matches(PK_FORMAT_REGEX, () => i18n.t('validation:pk.format'))
    .test('pk-validation', function (value) {
      if (PK_FORMAT_REGEX.test(value || '') && pkValidation(value || '', this.parent)) {
        return true;
      }
      return this.createError({ message: i18n.t('validation:pk.validation') });
    })
    .required(() => i18n.t('validation:required')),
  actionTrack: string().required(() => i18n.t('validation:required')),
  actionDirection: directionRequired
    ? string().required(() => i18n.t('validation:required'))
    : string().nullable().optional(),
  // Fix 2026-07-04 (misma familia que margin en NewWorkOrderForm): el campo
  // Margen vive tras el flag showMargin — solo puede ser obligatorio si se
  // muestra; si no, el guardado final era imposible.
  actionMargin: marginRequired
    ? string().required(() => i18n.t('validation:required'))
    : string().nullable().optional(),
  actionCoordinates: string(),
  actionLane: string().required(() => i18n.t('validation:required')),
});

// Backward compat: default schema con direction required
export const LocationSchema = createLocationSchema(true);
